import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dealer from 'pages/dealer/Dealer';

const DealerRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Dealer />} />
    </Routes>
  );
};

export default DealerRouter;
